import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HomeService } from 'src/app/services/home.service';
import { servicesUrl } from 'src/app/services/servicesUrl';

@Component({
  selector: 'app-research-projects-details',
  templateUrl: './research-projects-details.component.html',
  styleUrls: ['./research-projects-details.component.css']
})
export class ResearchProjectsDetailsComponent implements OnInit {

  constructor(private _Activatedroute: ActivatedRoute,private homeService_: HomeService,private imgUrl_:servicesUrl) { }
  id:any
 ResearchProjectName:string = ''
 ResearchProjectDsc:string = ''
 ResearchProjectDetails:string = ''
 ResearchProjectImg:string = ''
 load:boolean=false
 selectedItem: any
 arrayResearchProjectCategroy:any
 arrayResearchProject:any

  ngOnInit(): void {
    this.load = false
        this.id = this._Activatedroute.snapshot.paramMap.get("id")

        this.homeService_.getPost('getPost','', 'en', '', 'ProjectCategory', 'NTROOT0', '', '-1').subscribe(data => {
          this.arrayResearchProjectCategroy = data
         
         
         
          this.homeService_.getPost('getPostById',this.id, 'en', '', 'Projects', '', '', '1').subscribe(data => {
            let arr = data as any[]
            this.ResearchProjectName = arr[0]['postTitle']
            this.ResearchProjectDsc = arr[0]['postSubTitle']
            this.ResearchProjectDetails = arr[0]['postDetails']
            this.ResearchProjectImg = this.imgUrl_.imgUrl+arr[0]['postImage']
            this.load = true
          })
          });
      }

}
